import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  Icon,
  Typography,
} from "@mui/material";
import axios from "axios.js";
import React, { createContext, useState, useContext, useEffect } from "react";
import { useLocation as domUseLocation } from "react-router-dom";
import WarningIcon from "assets/images/icons/custom/warning.png";

const LocationContext = createContext(null);
export const useAppLocation = () => useContext(LocationContext);

export const LocationProvider = ({ children }) => {
  const domLocation = domUseLocation();
  const [appLocation, setAppLocation] = useState(null);
  const [permissionStatus, setPermissionStatus] = useState("prompt");
  const [lastLogTime, setLastLogTime] = useState(null);

  const updateAppLocation = () => {
    if ("geolocation" in navigator) {
      navigator.geolocation.getCurrentPosition(
        (position) => {
          setAppLocation({
            lat: position.coords.latitude,
            lng: position.coords.longitude,
          });
          setPermissionStatus("granted");

          // Push to server
          if (appLocation === null) {
            return;
          }

          if (lastLogTime) {
            if (Date.now() - lastLogTime < 20000) {
              return;
            }
          }
          const json = {
            latitude: position.coords.latitude,
            longitude: position.coords.longitude,
          };
          axios
            .post("agents/footprint.json", json)
            .then((result) => {
              setLastLogTime(Date.now());
            })
            .catch(() => {
              console.log(
                "An unexpected error occurred. Please try again later.",
              );
            });
        },
        (error) => {
          console.error(error);
          setPermissionStatus("denied");
        },
      );
    } else {
      setPermissionStatus("unsupported");
    }
  };

  useEffect(() => {
    updateAppLocation();
  }, [domLocation]);

  return (
    <LocationContext.Provider
      value={{
        applocation: appLocation,
        permissionStatus,
        lastLogTime,
        updateAppLocation,
      }}
    >
      <>
        <Dialog
          open={permissionStatus === "denied" ? true : false}
          fullWidth
          maxWidth="xs"
        >
          <DialogContent>
            <Box mt={3} align="center" mb={3}>
              <Box>
                <img src={WarningIcon} alt="error" width={64} />
              </Box>
              <Box mt={1}>
                <Typography variant="h6" fontWeight="light">
                  <b>Location access is required.</b>
                  <br />
                  <br />
                  To enable it, click the lock icon (🔒) or info icon (ⓘ) in the
                  address bar, find the "Location" permission, and choose
                  "Allow" or "Ask" to see it again.
                </Typography>
              </Box>
            </Box>
          </DialogContent>
          <DialogActions>
            <Button
              mr={3}
              onClick={() => {
                window.location.reload(true);
              }}
              color="primary"
              startIcon={<Icon>east</Icon>}
            >
              Proceed
            </Button>
          </DialogActions>
        </Dialog>
        <Box>{children}</Box>
      </>
    </LocationContext.Provider>
  );
};
